import { ComponentInterface } from 'typings'
import Icon from 'ui/atoms/Icon'
import {
  StyledH2,
  StyledTextfield,
  Subtext
} from 'pages/InfoRequestPage.styles'
import Calendar from 'ui/atoms/Calendar'
import useCustomTranslation from 'hooks/useCustomTranslation'
import { Grid, GridHeading } from './RequestPage.styles'

const PersonalInformation = ({
  formValues,
  handleOnChange,
  handleOnBlur
}: ComponentInterface): JSX.Element => {
  const t = useCustomTranslation('form.personal')

  return (
    <>
      <GridHeading>
        <StyledH2>{t('title')}</StyledH2>
      </GridHeading>
      <Grid>
        <StyledTextfield
          type="text"
          id="firstName"
          name="firstName"
          placeholder={t('firstName')}
          error={formValues.errors.firstName}
          value={formValues.firstName}
          onChange={e =>
            handleOnChange('firstName', (e.target as HTMLInputElement).value)
          }
          onBlur={() => !formValues.firstName && handleOnBlur('firstName')}
          autoComplete="given-name"
          maxLength={50}
          errorIcon={Icon('error')}
          data-testid="first-name"
        />
        <StyledTextfield
          type="text"
          id="lastName"
          name="lastName"
          placeholder={t('lastName')}
          error={formValues.errors.lastName}
          value={formValues.lastName}
          onChange={e =>
            handleOnChange('lastName', (e.target as HTMLInputElement).value)
          }
          onBlur={() => !formValues.lastName && handleOnBlur('lastName')}
          autoComplete="family-name"
          maxLength={50}
          errorIcon={Icon('error')}
          data-testid="last-name"
        />
      </Grid>
      <Grid>
        <Calendar
          formValues={formValues}
          handleOnChange={value => handleOnChange('dateOfBirth', value)}
          handleOnBlur={() =>
            !formValues.dateOfBirth && handleOnBlur('dateOfBirth')
          }
          testId="d-o-b"
        />
      </Grid>
      <Subtext style={{ marginTop: '1.5rem ' }}>{t('subtext')}</Subtext>
    </>
  )
}

export default PersonalInformation
